import type { ReactNode } from 'react';

import { Card } from '@/components/ui/card';

import { MediaButtons, type MediaButtonsProps } from './media-buttons';
import { TabButtons } from './tab-buttons';

export type MediaDataLayoutProps = {
  children?: ReactNode;
  page: string;
  isEditable?: boolean;
} & MediaButtonsProps;

export const MediaDataLayout = ({
  children,
  page,
  isEditable = true,
  ...props
}: MediaDataLayoutProps) => {
  return (
    <Card className="px-20 py-6 max-xl:px-10 max-sm:p-5">
      {isEditable && (
        <div className="flex w-full justify-center sm:justify-between">
          <TabButtons page={page} />
          <MediaButtons {...props} />
        </div>
      )}
      {children}
    </Card>
  );
};
